import React from 'react';
import { Segment } from 'semantic-ui-react';
import './styles.css';

function Quote({ text, author, backgroundColor = '#f5f5f5', align = 'center', inverted = false }) {
  const alignClass = align === 'left' ? 'align-left' : align === 'right' ? 'align-right' : 'align-center';
  const invertedClass = inverted ? 'inverted' : 'regular';

  return (
    <Segment 
      vertical 
      className="quote-segment"
    >
      <div 
        className={`quote-wrapper ${invertedClass}`}
        style={{ backgroundColor }}
      >
        <div className={`quote-content ${alignClass} ${invertedClass}`}>
          <blockquote className={`quote-blockquote ${invertedClass}`}>
            "{text}"
          </blockquote>
          <cite className={`quote-author ${invertedClass}`}>
            — {author}
          </cite>
        </div>
      </div>
    </Segment>
  );
}

export default Quote;
